import { motion } from "framer-motion";

const Privacy = () => {
  return (
    <motion.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
      className="pt-24 pb-16 px-4"
    >
      <div className="max-w-3xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">
          Privacy Policy
        </h1>

        <div className="prose prose-gray max-w-none space-y-6 text-gray-700">
          <p>
            This website displays posts from our Facebook business page using
            the Facebook API. We do not collect, store, or process personal
            data from visitors through Facebook. The Facebook data displayed on
            this website consists only of publicly available posts from our own
            Facebook page.
          </p>
          <p>We do not sell or share personal data with third parties.</p>
          <p>
            If you have questions about this policy, contact:{" "}
            <a
              href="mailto:dominicbrown@sandhurstinteriors.co.uk"
              className="text-primary-600 hover:text-primary-700 underline"
            >
              dominicbrown@sandhurstinteriors.co.uk
            </a>
          </p>

          <h2 className="text-xl font-semibold text-gray-900 mt-10 mb-4">
            Facebook Data Deletion Instructions
          </h2>
          <p>
            If you wish to request deletion of any data associated with our
            Facebook integration, please contact us at:{" "}
            <a
              href="mailto:dominicbrown@sandhurstinteriors.co.uk"
              className="text-primary-600 hover:text-primary-700 underline"
            >
              dominicbrown@sandhurstinteriors.co.uk
            </a>
          </p>
          <p>We will respond and process the request within 7 days.</p>
        </div>
      </div>
    </motion.main>
  );
};

export default Privacy;
